export function formatDate(date: string | Date, options?: Intl.DateTimeFormatOptions): string {
  const d = typeof date === 'string' ? new Date(date) : date
  return d.toLocaleDateString('id-ID', {
    timeZone: 'UTC',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    ...options
  })
}

export function formatDateShort(date: string | Date): string {
  return formatDate(date, { year: 'numeric', month: 'short', day: 'numeric' })
}
